import { observer } from 'mobx-react-lite';
import { PropertyBlock } from '../../../models/userTypes';
import Hazards from '../../sprayplan_report/production_areas/Hazards';

interface Props {
  productionArea: PropertyBlock | null | undefined;
}

const ReportHazards = ({ productionArea }: Props): JSX.Element => {
  return (
    <div>
      <h5 className='sub-heading mb-3 font-weight-bold'>Hazards</h5>
      {!productionArea ? (
        <p>No production area to show hazards</p>
      ) : (
        <Hazards productionArea={productionArea} />
      )}
    </div>
  );
};

export default observer(ReportHazards);
